export default {
  data() {
    return {
        contentLoaded: false,
      immutableDeskLinks: [],
      mutableDeskLinks: []
    };
  },
  methods: {
    getDesksList() {
      this.$restClient.deskDetails
        .all()
        .then((response) => {
          let data = response.data;
          if (data.length > 0) {
            this.immutableDeskLinks = data;
            let mutableDeskLinks = [];
            data.forEach((desk) => {
              mutableDeskLinks[desk.deskId] = {
                waitingRoomId: desk.waitingRoomId,
                userId: desk.userId,
              };
            });
            this.mutableDeskLinks = mutableDeskLinks;
            this.contentLoaded = true;
          }
        })
        .catch((err) => {
          console.log(err);
          this.$notify.notifyError({ title: this.$t("failed") });
        });
    },
  },
};
